import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useCreateWishListMutation } from "appRedux/slices/wishListApiSlice"
import { updateSearchedUserIsLoggedInUser } from "appRedux/slices/globalSlice"
import { useAuth } from "context/AuthContext"
import WishListForm from "components/templates/WishListForm"

export default function CreateNewListPage() {
  const [createWishList, createWishListResult] = useCreateWishListMutation()

  const { user } = useAuth()

  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updateSearchedUserIsLoggedInUser(true))
  }, [])

  useEffect(() => {
    if (createWishListResult.status === "fulfilled") {
      handleWishListCreatedSuccessfully(createWishListResult.data.id)
    }
  }, [createWishListResult])

  function handleWishListCreatedSuccessfully(id: number) {
    if (!user?.handle) return
    navigate(`/user/${user.handle}/list/${id}`, { replace: true })
  }

  function isCTADisabled(dirtyFields: object) {
    const disabled = !dirtyFields.hasOwnProperty("name") || createWishListResult.isLoading
    console.log("[DEBUG] isCTADisabled", { dirtyFieldKeys: Object.keys(dirtyFields), isLoading: createWishListResult.isLoading, disabled })
    return disabled
  }

  function handleCreateNewList(value: WishListRequestPayload) {
    createWishList(value)
  }

  return (
    <WishListForm
      isCTADisabled={isCTADisabled}
      isCTALoading={() => createWishListResult.isLoading}
      onSubmit={handleCreateNewList}
    />
  )
}
